import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CareersPage from "@/pages/CareersPage";

export const Route = createFileRoute("/careers/")({
  head: () => pageHead("Careers", "Join AKIVA. We hire engineers, data and IT specialists, program managers, and consultants across commercial and government engagements.", "/careers", false),
  component: CareersPage,
});
